<template>
  <div class="spin" v-if="start" style="
      z-index: 9999999999999999999999999999999999999999999999999999999999999999999999 !important;
    ">
    <div class="ring">
      <div class="looping-rhombuses-spinner">
        <div class="rhombus"></div>
        <div class="rhombus"></div>
        <div class="rhombus"></div>
        <br />
        <div>
          <h6 class="mt-2 mr-n2" style="font-size: 11px;width: 250px;">لطفا منتظر بمانید...</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['start'],
};
</script>

<style scoped>
.spin {
  z-index: 9999999999999999999999999999999999999999999999999999999999999999999999 !important;
  width: 100%;
  height: 100%;
  background-color: #77777783;
  position: absolute;
}

.ring {
  position: fixed;
  top: 50%;
  right: 50%;
  margin: 0 auto;
  height: 100%;
}

@media only screen and (max-width: 600px) {
  .ring {
    position: fixed;
    top: 50%;
    right: 46%;
    margin: 0 auto;
    height: 100%;
  }
}

.looping-rhombuses-spinner,
.looping-rhombuses-spinner * {
  box-sizing: border-box;
}

.looping-rhombuses-spinner {
  width: calc(15px * 4);
  height: 15px;
  position: relative;
}

.looping-rhombuses-spinner .rhombus {
  height: 15px;
  width: 15px;
  background-color: var(--light-color);
  left: calc(15px * 4);
  position: absolute;
  margin: 0 auto;
  border-radius: 2px;
  transform: translateY(0) rotate(45deg) scale(0);
  animation: looping-rhombuses-spinner-animation 2500ms linear infinite;
}

.looping-rhombuses-spinner .rhombus:nth-child(1) {
  animation-delay: calc(2500ms * 1 / -1.5);
}

.looping-rhombuses-spinner .rhombus:nth-child(2) {
  animation-delay: calc(2500ms * 2 / -1.5);
}

.looping-rhombuses-spinner .rhombus:nth-child(3) {
  animation-delay: calc(2500ms * 3 / -1.5);
}

@keyframes looping-rhombuses-spinner-animation {
  0% {
    transform: translateX(0) rotate(45deg) scale(0);
  }

  50% {
    transform: translateX(-233%) rotate(45deg) scale(1);
  }

  100% {
    transform: translateX(-466%) rotate(45deg) scale(0);
  }
}
</style>
